<div>
    <!-- breadcrumb area start -->
    <vb-breadcrumb-one title="Watchlist"></vb-breadcrumb-one>
    <!-- breadcrumb area end -->

    <!-- shop area start -->
    <section class="tp-shop-area pb-120">
        <div class="container-fluid">
            <!-- tp-shop-main-wrapper -->
            <div>
                <div class="tp-shop-main-wrapper">
                    <div class="tp-shop-top mb-45">
                        <!-- Search, view toggle, and filter button — one row. -->
                        <div class="tp-shop-toolbar d-flex flex-wrap align-items-center">
                            <vb-search
                                #searchBar
                                class="tp-shop-search"
                                placeholder="Search your watchlist"
                                ariaLabel="Search your watchlist"
                                [delegateSearch]="true"
                                (search)="onSearch($event)" />
                            <div
                                class="tp-shop-top-left d-flex align-items-center">
                                <!-- Grid/list toggle — hidden while the
                                      compact view is active (≤639px):
                                      compact is an automatic view, not a
                                      blocked choice. -->
                                <div class="tp-shop-top-tab tp-tab" *ngIf="!compactView">
                                    <ul class="nav nav-tabs">
                                        <li
                                            class="nav-item"
                                            role="presentation">
                                            <button
                                                [ngClass]="{
                                                    'nav-link': true,
                                                    active:
                                                        activeTab === 'grid'
                                                }"
                                                (click)="
                                                    handleActiveTab('grid')
                                                ">
                                                <img
                                                    src="/assets/viewbid/images/grid-icon.svg"
                                                    alt="Grid View" />
                                            </button>
                                        </li>
                                        <li
                                            class="nav-item"
                                            role="presentation">
                                            <button
                                                [ngClass]="{
                                                    'nav-link': true,
                                                    active:
                                                        activeTab === 'list'
                                                }"
                                                (click)="
                                                    handleActiveTab('list')
                                                ">
                                                <img
                                                    src="/assets/viewbid/images/list-icon.svg"
                                                    alt="List View" />
                                            </button>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div
                                class="tp-shop-top-actions d-sm-flex align-items-center watchlist-filter-controls">
                                <div class="watchlist-filter-group">
                                    <vb-button
                                        [variant]="
                                            appliedFilterCount > 0
                                                ? 'primary'
                                                : 'secondary'
                                        "
                                        size="md"
                                        [iconLeft]="filterIcon"
                                        (clicked)="openFilterModal()">
                                        {{
                                            'AuctionsPage.filtersLabel'
                                                | translate
                                        }}
                                        <span
                                            *ngIf="
                                                appliedFilterCount > 0
                                            "
                                            class="lot-filter-badge">
                                            {{ appliedFilterCount }}
                                        </span>
                                    </vb-button>
                                    <ng-template #filterIcon>
                                        <vb-icon
                                            name="filter"
                                            [size]="16"></vb-icon>
                                    </ng-template>
                                    <button
                                        *ngIf="appliedFilterCount > 0"
                                        type="button"
                                        class="lot-filter-clear"
                                        (click)="clearFilters()">
                                        {{
                                            'AuctionsPage.clearAllLabel'
                                                | translate
                                        }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <vb-paginator-bar
                        *ngIf="!isLoading && !unableToLoad && mappedRows.length > 0"
                        variant="top"
                        label="lots"
                        [dense]="isMobile"
                        [current]="paginate.currentPage ?? 1"
                        [total]="paginate.totalPages ?? 0"
                        [totalItems]="paginate.totalItems ?? 0"
                        [perPage]="pageSize"
                        [perPageOptions]="pageSizeOptions"
                        (pageChange)="onPageChange($event)"
                        (perPageChange)="setPageSize($event)">
                    </vb-paginator-bar>

                    <div class="tp-shop-items-wrapper tp-shop-item-primary">
                        <!-- Unable to Load -->
                        <div
                            *ngIf="unableToLoad"
                            class="cartmini__empty min-height-30">
                            <img
                                src="/assets/img/product/cartmini/empty-cart.png"
                                alt="empty-cart-img" />
                            <h4>
                                Something went wrong, unable to load Lots!
                            </h4>
                        </div>
                        <!-- Loading Spinner -->
                        <div
                            *ngIf="isLoading && !unableToLoad"
                            class="vb-spinner-box vb-spinner-box--page">
                            <vb-spinner size="xl" label="Loading watchlist"></vb-spinner>
                        </div>
                        <div *ngIf="!isLoading && !unableToLoad">
                            <!-- if no item in watchlist -->
                            <div
                                *ngIf="mappedRows.length === 0"
                                class="cartmini__empty text-center min-height-30">
                                <img
                                    src="/assets/img/product/cartmini/empty-cart.png"
                                    alt="empty-cart-img" />
                                <h4 *ngIf="appliedFilterCount === 0">
                                    Watchlist is empty!
                                </h4>
                                <ng-container *ngIf="appliedFilterCount > 0">
                                    <h4>
                                        {{
                                            'AuctionsPage.noLotsMatchFilters'
                                                | translate
                                        }}
                                    </h4>
                                    <vb-button
                                        variant="secondary"
                                        size="md"
                                        (clicked)="clearFilters()">
                                        {{
                                            'AuctionsPage.clearFiltersLabel'
                                                | translate
                                        }}
                                    </vb-button>
                                </ng-container>
                            </div>
                            <!-- Lots -->
                            <div
                                *ngIf="mappedRows.length > 0"
                                class="row infinite-container"
                                [class.gx-3]="effectiveTab === 'grid'"
                                [class.lot-card-list]="effectiveTab === 'list'">
                                <ng-container
                                    *ngFor="let row of mappedRows; trackBy: trackByRow">
                                    <!-- Column classes live on a wrapper div (like the auction
                                          lot list page), never on the card host: Bootstrap's
                                          gutter padding on the host insets the card's content
                                          from its own border/state ring. -->
                                    <div
                                        class="mb-3 d-flex flex-column col-12"
                                        [class.col-md-6]="effectiveTab === 'grid'"
                                        [class.col-xl-4]="effectiveTab === 'grid'">
                                        <vb-lot-card
                                            class="flex-fill"
                                            [lot]="row.lot"
                                            [auction]="row.auction"
                                            [viewMode]="effectiveTab"
                                            [currentUserId]="currentUserId || null"
                                            [userHasBid]="userHasBidOn(row.lot)"
                                            [countdownValue]="countdownTracker.countdowns[row.auctionLotId] || null"
                                            [biddingEnded]="isLotBiddingEnded(row.lot)"
                                            [graceMs]="graceMs"
                                            [bidLoading]="bidLoadingByLot[row.auctionLotId] || false"
                                            watchlistAriaLabel="Toggle watchlist"
                                            (watchlistUpdated)="onWatchlistUpdated($event)"
                                            (bidPlaced)="onQuickBidPlaced(row)"
                                            (customBidPlaced)="onCustomBidPlaced(row, $event)"
                                            (bidRounded)="onBidRounded()"
                                            (lotHidden)="handleLotHidden()"
                                            (loadingComplete)="handleLoadingComplete()">
                                        </vb-lot-card>
                                    </div>
                                </ng-container>
                            </div>
                            <vb-paginator-bar
                                *ngIf="mappedRows.length > 0"
                                variant="bottom"
                                label="lots"
                                [dense]="isMobile"
                                [current]="paginate.currentPage ?? 1"
                                [total]="paginate.totalPages ?? 0"
                                [totalItems]="paginate.totalItems ?? 0"
                                [perPage]="pageSize"
                                (pageChange)="onPageChange($event)">
                            </vb-paginator-bar>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div>
                    <vb-auction-summary
                        class="watchlist-summary"
                        [auction]="auction"
                        [fullWidth]="true" />
                    <vb-ad-card />
                </div>
            </div>
        </div>
    </section>
    <!-- shop area end -->

    <vb-lot-filter-modal
        [open]="filterModalOpen"
        [draft]="filterDraft"
        [matchCount]="filterMatchCount"
        [totalCount]="filterTotalCount"
        [categories]="filterCategories"
        [categoryCounts]="filterCategoryCounts"
        (draftChange)="onFilterDraftChange($event)"
        (apply)="onFilterApply()"
        (closed)="onFilterClosed()">
    </vb-lot-filter-modal>

    <!-- Bid confirmation (library dialog, same as lot details) -->
    <vb-bid-confirm-dialog
        [open]="confirmDialogOpen"
        [amount]="pendingBidAmount"
        [bpPct]="pendingBidBpPct"
        (confirmed)="onBidConfirmed($event)"
        (cancelled)="onBidCancelled()" />

    <div>
        <div
            style="
                z-index: 100;
                left: 100% !important;
                margin-left: 5%;
                box-shadow: 0 30px 50px #052f281f;
            "
            class="tp-filter-offcanvas-area"
            [class.offcanvas-opened]="!productService.showNotes">
            <div class="tp-filter-offcanvas-wrapper">
                <div class="tp-filter-offcanvas-close">
                    <button
                        (click)="handleNotesCanvas()"
                        type="button"
                        class="tp-filter-offcanvas-close-btn filter-close-btn">
                        <i class="fa-solid fa-xmark"></i>
                        Close
                    </button>
                </div>

                <div class="tp-shop-sidebar">
                    <div
                        class="d-flex tp-shop-widget mb-2 justify-content-between menu-icon-wrapper">
                        <h5>Lot Notes:</h5>
                        <img
                            src="../../../../../../assets/img/icon/icon_ellipses.svg"
                            class="menu-icon"
                            alt="More"
                            tabindex="0"
                            data-bs-toggle="tooltip"
                            title="More"
                            mat-Button
                            [matMenuTriggerFor]="menu"
                            #popoverImage />
                    </div>
                    <table style="width: fit-content">
                        <thead>
                            <tr>
                                <th class="first-column">Date/Time</th>
                                <th class="second-column">Notes</th>
                            </tr>
                        </thead>
                        <tbody class="table-body">
                            <tr
                                *ngFor="
                                    let note of productService.lotItemUserNotes
                                ">
                                <td class="first-column">
                                    {{ note.createdOn | vbDateTime }}
                                </td>
                                <td
                                    class="second-column"
                                    [innerHTML]="
                                        sanitizeHtml(note.note ?? '')
                                    "></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <mat-menu #menu="matMenu">
                <a
                    [routerLink]="[
                        '/auctions',
                        productService.notesAuctionId,
                        'lot',
                        productService.notesLotId
                    ]"
                    [queryParams]="{ showNotes: true }"
                    ><div
                        class="d-flex align-items-center clickable-text notes-menu ps-3 pe-3">
                        <img
                            src="../../../../../../assets/img/icon/icon_edit.svg"
                            alt="edit icon" />
                        <p class="mt-3 ms-2">Edit Notes</p>
                    </div></a
                >
            </mat-menu>
        </div>
    </div>
</div>
